import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ProfileProviderPF, ProfileProviderPfControllerService } from '../../core/generated';

@Injectable({
  providedIn: 'root'
})
export class ProfileProviderPFStateService {
  private profileProviderPFService = inject(ProfileProviderPfControllerService);
  private profileProviderPFSubject = new BehaviorSubject<ProfileProviderPF | null>(null);

  get profileProviderPF$(): Observable<ProfileProviderPF | null> {
    return this.profileProviderPFSubject.asObservable();
  }

  loadById(id: number) {
    this.profileProviderPFService.findById7(id).subscribe({
      next: (profile) => {
        // Valida se o perfil tem ID válido, senão considera como null
        const validProfile = profile && profile.id ? profile : null;
        this.profileProviderPFSubject.next(validProfile);
      },
      error: (err) => {
        console.error('ProfileProviderPFStateService: erro ao carregar perfil por ID', id, err);
        this.profileProviderPFSubject.next(null);
      }
    });
  }

  loadByEmail(email: string) {
    this.profileProviderPFService.findByUserEmail1(email).subscribe({
      next: (profile) => {
        // Valida se o perfil tem ID válido, senão considera como null
        const validProfile = profile && profile.id ? profile : null;
        this.profileProviderPFSubject.next(validProfile);
      },
      error: (err) => {
        console.error('ProfileProviderPFStateService: erro ao carregar perfil para', email, err);
        // Em caso de erro, emite null para indicar que a tentativa de carregamento foi concluída
        this.profileProviderPFSubject.next(null);
      }
    });
  }

  setProfile(profile: ProfileProviderPF) {
    this.profileProviderPFSubject.next(profile);
  }

  updateProfile(updatedProfile: ProfileProviderPF) {
    this.profileProviderPFSubject.next(updatedProfile);
  }

  removeProfile() {
    this.profileProviderPFSubject.next(null);
  }

  refreshByEmail(email: string) {
    this.loadByEmail(email);
  }

  clear() {
    this.profileProviderPFSubject.next(null);
  }
}
